import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ITemplateType } from 'src/app/models/i-template-type';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { TemplatesService } from 'src/app/services/templates.service';

@Component({
  selector: 'app-legal-templates',
  templateUrl: './legal-templates.component.html',
  styleUrls: ['./legal-templates.component.css']
})
export class LegalTemplatesComponent implements OnInit {
  TemplateTypeForm: FormGroup;
  TemplateTypes: ITemplateType[];

  constructor(
    private router: Router,
    private templatesService: TemplatesService, 
    private blockUiHanddler: BlockUiHandlerService,
    private alertsService: AlertsService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.InitVariables();
  }

  InitVariables(): void {
    this.TemplateTypes = [];
    this.ResetTemplateForm();
    this.LoadTemplateTypes();
  }

  LoadTemplateTypes(){
    this.blockUiHanddler.Start(1, 'Cargando tipos de formatos...')
    this.templatesService.GetTemplateTypes().subscribe(req => {
      this.blockUiHanddler.Stop();
      if(req.Result){
        this.TemplateTypes = req.Data;
        if(this.TemplateTypes.length > 0) this.TemplateTypeForm.controls["TemplateType"].setValue(this.TemplateTypes[0].Id)
      } else {
        this.alertsService.ShowSmallCornerAlert('Ocurrió un error al cargar los Templates', 2)
      }
    }, err => {
      this.blockUiHanddler.Stop();
      this.alertsService.ShowSmallCornerAlert(err, 2);
    });
  }

  ResetTemplateForm(): void {
    this.TemplateTypeForm = this.formBuilder.group({
      TemplateType: ['0', Validators.required]
    });
  }

  fillTemplate(){
    let TemplateType:number = this.TemplateTypeForm.controls['TemplateType'].value
    this.router.navigate(['/legal-templates',TemplateType])
  }

}
